
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.695.695a.983.983 0 011.39 0l15.22 15.22a.983.983 0 01-1.39 1.39L.695 2.085a.983.983 0 010-1.39z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.305.695a.983.983 0 00-1.39 0L.695 15.915a.983.983 0 101.39 1.39l15.22-15.22a.983.983 0 000-1.39z"}})])
          )
        }
      }
    